// @ts-nocheck
'use client';

import { memo, useEffect } from 'react';

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
  AvatarIcon,
  Avatar as UIAvatar,
} from '@nextui-org/react';
import { Spinner } from '@nextui-org/spinner';
import {
  Image as ImageIcon,
  LogOut,
  Settings,
  User,
} from 'lucide-react';
import { useRouter } from 'next/navigation';
import { signOut } from 'next-auth/react';
import { useMeQuery } from '@/entities/me/meQueries';
import { useIsAdmin } from '@/shared/hooks/is-admin';
import { useIsAuthorizated } from '@/shared/hooks/is-authorizated';
import { useDisplayProfile } from '@/shared/hooks/use-display-profile';
import { useSession } from '@/shared/hooks/use-session';
import { externalAvatarImgProps } from '@/shared/const/telegram-account';
import { ROUTES } from '@/shared/routes/routes';
import { LoginBtn } from '@/components/ui/buttons/login-btn';

export const Avatar = memo(({ size: _size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) => {
  const router = useRouter();
  useEffect(() => {
    // Prefetch the page
    router.prefetch(ROUTES.me);
    router.prefetch(ROUTES.meMasterclasses);
    router.prefetch(ROUTES['admin-front']);
  }, [router]);

  const { isPending: userIsPending } = useMeQuery();
  const { user: sessionUser, isPending: sessionIsPending } = useSession();
  const { isAuthorizated, isPending } = useIsAuthorizated();
  const { isAdmin } = useIsAdmin();
  const { image: displayImage, displayName } = useDisplayProfile();

  if (!isAuthorizated) {
    return <LoginBtn />;
  }
  const avatarSrc = displayImage;
  return (
    <>
      {isPending || userIsPending || sessionIsPending ? (
        <Spinner color="default" />
      ) : (
        <Dropdown placement="bottom-end">
          <DropdownTrigger>
            {avatarSrc ? (
              <UIAvatar
                className="cursor-pointer"
                isBordered
                src={avatarSrc}
                imgProps={externalAvatarImgProps}
              />
            ) : (
              <UIAvatar
                className="cursor-pointer"
                icon={<AvatarIcon size={18} strokeWidth={1.25} />}
              />
            )}
          </DropdownTrigger>

          <DropdownMenu aria-label="Profile Actions" variant="flat">
            <DropdownSection showDivider>
              <DropdownItem key="profile">
                <p className="font-semibold">
                  {sessionUser?.name ?? sessionUser?.email ?? displayName}
                </p>
              </DropdownItem>
            </DropdownSection>
            <DropdownItem
              onClick={() => {
                router.push(ROUTES.me);
              }}
              startContent={<User size={20} strokeWidth={1.25} />}
              key="profile"
            >
              Профиль
            </DropdownItem>
            {/* @ts-ignore */}
            {isAdmin ? (
              <DropdownItem
                onClick={() => {
                  router.push(ROUTES['admin-front']);
                }}
                startContent={<Settings size={20} strokeWidth={1.25} />}
                key="profile"
              >
                Администрирование
              </DropdownItem>
            ) : null}
            <DropdownItem
              onClick={() => {
                router.push(ROUTES.meMasterclasses);
              }}
              startContent={<ImageIcon size={20} strokeWidth={1.25} />}
              key="profile"
            >
              Мои покупки
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                signOut();
              }}
              key="logout"
              color="danger"
              startContent={<LogOut size={20} strokeWidth={1.25} />}
            >
              Выйти
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      )}
    </>
  );
});

Avatar.displayName = 'Avatar';
